export const SAVE_CONFIGURATION = "SAVE_CONFIGURATION";

export const saveConfiguration = configuration => {
  return {
    type: SAVE_CONFIGURATION,
    payload: configuration
  };
};



// WEBPACK FOOTER //
// ./src/actions/saveConfiguration.js